import { createSlice } from '@reduxjs/toolkit'
import {
  fetchAllModulesDropdowns,
  fetchModules
} from './thunk'

interface ModuleState {
  modulesList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  appNameDropDown: any[];
  industryTypeDropDown: any[];
  orgCityDropDown: any[];
  orgStateDropDown: any[];
  pincodeDropDown: any[];
  exportCSVLoading: boolean;
  exportCSVError: string | null;
}

const initialState: ModuleState = {
  modulesList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  appNameDropDown: [],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  exportCSVLoading: false,
  exportCSVError: null,
};

const modulesSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch All Organisations
      .addCase(fetchModules.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchModules.fulfilled, (state, action) => {
        state.loading = false
        state.modulesList = Array.isArray(action.payload.data)
          ? action.payload.data
          : []
        state.rowCount =
          typeof action.payload.rowCount === 'number'
            ? action.payload.rowCount
            : 0
      })
      .addCase(fetchModules.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch organisations'
      })

    //   // Fetch Single Organisation by ID
    //   .addCase(fetchModulesByID.pending, state => {
    //     state.loading = true
    //     state.error = null
    //   })
    //   .addCase(fetchModulesByID.fulfilled, (state, action) => {
    //     state.loading = false
    //     state.selectedOrganisation = action.payload
    //   })
    //   .addCase(fetchModulesByID.rejected, (state, action) => {
    //     state.loading = false
    //     state.error = action.payload as string
    //   })

    //   // Update Organisation
    //   .addCase(updateModules.fulfilled, (state, action) => {
    //     if (!action.payload?.id) return
    //     state.modulesList = state.modulesList.map(org =>
    //       org.id === action.payload.id ? action.payload : org
    //     )
    //   })
    //   .addCase(updateModules.rejected, (state, action) => {
    //     state.loading = false
    //     state.error = action.error.message || 'Failed to update organisation'
    //   })

    //   // Update Status
    //   .addCase(updateModules.fulfilled, (state, action) => {
    //     if (!action.payload?.id) return
    //     state.modulesList = state.modulesList.map(org =>
    //       org.id === action.payload.id ? action.payload : org
    //     )
    //   })
    //   .addCase(updateModuelsSTtaus.rejected, (state, action) => {
    //     state.loading = false
    //     state.error =
    //       action.error.message || 'Failed to update organisation status'
    //   })
    builder.addCase(fetchAllModulesDropdowns.fulfilled, (state, action) => {
      console.log("action.payload. : ",action.payload);
      state.appNameDropDown = action.payload.appNameDropDown || [];
      // state.industryTypeDropDown = action.payload.industryTypeDropDown || []
      // state.orgCityDropDown = action.payload.orgCityDropDown || []
      // state.orgStateDropDown = action.payload.orgStateDropDown || []
      // state.pincodeDropDown = action.payload.pincodeDropDown || []
    })
    //   .addCase(exportModulesCSV
    //     .pending, (state) => {
    //       state.exportCSVLoading = true;
    //       state.exportCSVError = null;
    //     })
    //   .addCase(exportModulesCSV
    //     .fulfilled, (state) => {
    //       state.exportCSVLoading = false;
    //       state.exportCSVError = null;
    //     })
    //   .addCase(exportModulesCSV
    //     .rejected, (state, action) => {
    //       state.exportCSVLoading = false;
    //       state.exportCSVError = typeof action.payload === 'string'
    //         ? action.payload
    //         : (action.error.message || 'Failed to export CSV');
    //     });

  }
})

export default modulesSlice.reducer
